module.exports = __webpack_public_path__ + "static/pdr-small-b28f9cd3835e1e974ddbbedaba80c407.png";